// @flow

import React, { Component } from 'react';
import { connect } from 'react-redux';

import { tutorLogout, subscribeToCalendar, unsubscribeFromCalendar } from 'actions/tutor';
import CalendarSyncModal from './calendar-sync-modal';

import { SettingsCta } from './settings-cta';
import { Background, Wrap, Menu, MenuItems, MenuItem, MenuItemLink, RightMargin } from './styles';

type StatePropsType = {};

const mapStateToProps = (): StatePropsType => ({});

type DispatchPropsType = {
  dispatchTutorLogout: typeof tutorLogout,
  dispatchSubscribeToCalendar: typeof subscribeToCalendar,
  dispatchUnsubscribeFromCalendar: typeof unsubscribeFromCalendar,
};

const mapDispatchToProps: DispatchPropsType = {
  dispatchTutorLogout: tutorLogout,
  dispatchSubscribeToCalendar: subscribeToCalendar,
  dispatchUnsubscribeFromCalendar: unsubscribeFromCalendar,
};

type PropsType = StatePropsType & DispatchPropsType;

type StateType = {
  isOpen: boolean,
};

class SettingsDropdown extends Component<PropsType, StateType> {
  state = { isOpen: false };

  handleClick = () => this.setState(({ isOpen }) => ({ isOpen: !isOpen }));

  render() {
    const { isOpen } = this.state;
    const {
      dispatchTutorLogout,
      dispatchSubscribeToCalendar,
      dispatchUnsubscribeFromCalendar,
    } = this.props;

    return (
      <>
        {isOpen && <Background onClick={this.handleClick} />}
        <Wrap>
          <SettingsCta onClick={this.handleClick} />
          <Menu menuOpen={isOpen}>
            <SettingsCta isOpen onClick={this.handleClick} withCloseIcon />
            <MenuItems>
              <MenuItem>
                <CalendarSyncModal
                  subscribe={dispatchSubscribeToCalendar}
                  unsubscribe={dispatchUnsubscribeFromCalendar}
                />
              </MenuItem>
              <MenuItem>
                <MenuItemLink
                  href="https://support.hiclark.com"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  Help
                </MenuItemLink>
              </MenuItem>
              <MenuItem>
                <MenuItemLink as="button" onClick={dispatchTutorLogout}>
                  Logout
                </MenuItemLink>
              </MenuItem>
              <MenuItem>
                <RightMargin>
                  <MenuItemLink
                    small
                    href="https://www.hiclark.com/terms-of-service/"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    Terms
                  </MenuItemLink>
                </RightMargin>
                <MenuItemLink
                  small
                  href="https://www.hiclark.com/privacy-policy/"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  Privacy
                </MenuItemLink>
              </MenuItem>
            </MenuItems>
          </Menu>
        </Wrap>
      </>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SettingsDropdown);



// WEBPACK FOOTER //
// ./src/containers/settings-dropdown/index.js